import React from "react";
import { query_string } from "./queries";

const debug = query_string("debug");

interface MyInputProps {
    enabledStyle: Object,
    disabledStyle?: Object,
    hoverStyle?: Object,
    focusStyle?: Object,
    errorStyle?: Object,
    textErrorStyle?: Object,

    id?: string,
    className?: string,
    type: string,
    value?: any,
    placeholder?: string,

    disabled?: boolean,
    required?: boolean,

    isValid?: (value: string) => boolean,

    onChange?: (evt: React.ChangeEvent<HTMLInputElement>) => void,
}

function MyInput(props: MyInputProps) {
    const [hover, setHover] = React.useState(false);
    const [focus, setFocus] = React.useState(false);
    const [style, setStyle] = React.useState(props.enabledStyle || {});
    const [value, setValue] = React.useState(props.value || "");
    const [once, setOnce] = React.useState(false);
    const [disabled, setDisabled] = React.useState(props.disabled);
    const [required, setRequired] = React.useState(props.required);
    const [isEmpty, setIsEmpty] = React.useState(false);
    const [hasError, setHasError] = React.useState(false);

    React.useEffect(() => {
        if (disabled && props.disabledStyle) {
            setStyle(props.disabledStyle);
            return;
        }

        if (focus && props.focusStyle) {
            setStyle(props.focusStyle);
            return
        }

        if (isEmpty || hasError) {
            setStyle(props.errorStyle);
            return;
        }

        if (hover && props.hoverStyle)  {
            setStyle(props.hoverStyle);
            return;
        }

        setStyle(props.enabledStyle);
    }, [hover, focus, once, required, disabled, hasError, isEmpty]);

    React.useEffect(() => {
        if (once) {
            const tmp_value = value.trim();
            if (tmp_value === "") {
                setIsEmpty(true);
            } else {
                setIsEmpty(false);
            }
            if (props.isValid && !props.isValid(tmp_value)) {
                setHasError(true);
            } else {
                setHasError(false);
            }
        }
    }, [once, value]);

    React.useEffect(() => {
        setValue(props.value);
    }, [props.value]);

    React.useEffect(() => {
        setDisabled(props.disabled);
    }, [props.disabled]);

    React.useEffect(() => {
        setRequired(props.required);
    }, [props.required]);

    const changeHover = (hs: boolean) => (evt: React.MouseEvent<HTMLInputElement>) => {
        setHover(hs);
    }

    const changeFocus = (hs: boolean) => (evt: React.FocusEvent<HTMLInputElement>) => {
        setFocus(hs);
        if (hs == true) {
            setOnce(true);
        }
    }

    return <>
        <input
            id={props.id}
            onMouseEnter={changeHover(true)}
            onMouseLeave={changeHover(false)}
            onFocus={changeFocus(true)}
            onBlur={changeFocus(false)}
            className={props.className}
            type={props.type}
            style={style}
            value={value}
            placeholder={props.placeholder}
            onChange={props.onChange}
        />
        {isEmpty ? (
            <div style={props.textErrorStyle} className="fs-6 opacity-75">Veuillez renseigner ce champs</div>
        ) : hasError ? (
            <div style={props.textErrorStyle} className="fs-6 opacity-75">Ce champs est invalide</div>
        ) : (
            <div style={props.textErrorStyle} className="fs-6 opacity-75">&nbsp;</div>
        )}
    </>
}

export default MyInput;